module.exports = __webpack_public_path__ + "static/media/development.0aff720e.png";